import { MutationTree } from 'vuex'
import { FeatureFlagsState } from '@/@types'

const mutations: MutationTree<FeatureFlagsState> = {
  FEATURE_FLAGS_UPDATED: (state, newFlags) => {
    state.blackFridayEnabled = newFlags.blackFridayEnabled
    state.cyberMondayEnabled = newFlags.cyberMondayEnabled
  },
}

export default mutations
